// @ts-nocheck
import React from 'react'
import { Dropdown } from 'semantic-ui-react'

import { AutoFocusSemanticUiComponent } from 'components/AutoFocusSemanticUiComponent'
import { languageOption } from 'organisms/FeedbackFilterGroup/constants'

// Customer advanced filter needs to emit ISO codes ('en', 'th', 'zh-CN'),
// not full-name labels, because `Customer.language` stores codes. The
// sibling `LanguageInput` in `organisms/FeedbackFilterGroup/container.js`
// emits labels — Feedback's `Session.language` stores labels, so the two
// filter surfaces intentionally diverge on the wire format.
export default function CustomerLanguageInput({ defaultFilters, onChange }) {
  const optionMap = Object.entries(languageOption).map(([label, value]) => ({
    key: value,
    text: label,
    value,
  }))

  const optionByValue = Object.fromEntries(optionMap.map((opt) => [opt.value, opt]))

  const defaultValue = defaultFilters.map((filter) => filter.value)

  function handleChange(_, { value }) {
    onChange(
      value.map((code) => ({
        value: code,
        label: optionByValue[code].text,
      }))
    )
  }

  return (
    <AutoFocusSemanticUiComponent functionName="open">
      <Dropdown
        placeholder="Language"
        fluid
        multiple
        selection
        search
        onChange={handleChange}
        options={optionMap}
        defaultValue={defaultValue}
      />
    </AutoFocusSemanticUiComponent>
  )
}



// WEBPACK FOOTER //
// ./src/components/CustomerLanguageInput/index.tsx